"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const ui_1 = require("@rahtab/ui");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const ActivityIndicator_1 = __importDefault(require("./ActivityIndicator"));
const Header_1 = __importDefault(require("./Header"));
const HeaderTitle_1 = __importDefault(require("./HeaderTitle"));
const Loading_1 = __importDefault(require("./Loading"));
const system_1 = require("@rahtab/system");
const networkErrorText = 'اتصال خود را به اینترنت بررسی کنید.';
const serverErrorText = 'در پردازش درخواست شما مشکلی بوجود آمده است لطفا دوباره امتحان نمایید. در صورت تداوم این خطا با پشتیبانی تماس حاصل فرمایید.';
/** @deprecated use Screen from @rahtab/system */
function Screen({ data = undefined, headerShown = true, loading = false, transparentLoading = false, style, title, renderMain, renderControls, renderHeader, headerStyle, }) {
    const isMounted = react_1.useRef(true);
    const safeArea = react_native_safe_area_context_1.useSafeAreaInsets();
    const { height } = react_native_1.useWindowDimensions();
    const prevLoading = react_1.useMemo(() => {
        if (isMounted.current) {
            isMounted.current = false;
            return loading;
        }
        return !loading;
    }, [loading]);
    const networkLinkState = system_1.useSystemSelector((state) => {
        let initialNetworkLinkState = {
            hasError: false,
            hasNetworkError: false,
            isLoading: false,
        };
        for (const req of Object.values(state.networkLink.requests)) {
            if (req.loading) {
                initialNetworkLinkState.isLoading = true;
                return initialNetworkLinkState;
            }
            else if (req.error) {
                initialNetworkLinkState.hasError = true;
                if (req.error.code === system_1.networkLink.NetworkLinkErrorCode.NetworkError) {
                    initialNetworkLinkState.hasNetworkError = true;
                }
            }
        }
        return initialNetworkLinkState;
    });
    const alert = ui_1.useAlert();
    const dispatch = system_1.useSystemDispatch();
    const { retry } = system_1.networkLink;
    react_1.useEffect(() => {
        if (!networkLinkState.isLoading && networkLinkState.hasError && !prevLoading) {
            let message = serverErrorText;
            if (networkLinkState.hasNetworkError) {
                message = networkErrorText;
            }
            alert({
                title: 'خطا',
                severity: 'error',
                message,
                hideBackButton: true,
                buttons: [
                    {
                        color: 'secondary',
                        text: 'تلاش مجدد',
                        onPress: () => {
                            dispatch(retry());
                        },
                    },
                ],
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [networkLinkState.isLoading]);
    const errorCondition = prevLoading && !networkLinkState.isLoading && networkLinkState.hasError;
    const renderHeaderControls = () => {
        if (loading || !renderControls || errorCondition)
            return null;
        return react_1.default.createElement(react_native_1.View, { style: styles.headerControls }, renderControls(data));
    };
    const renderHeaderTitleOrCustomHeader = () => {
        if (renderHeader && errorCondition) {
            return null;
        }
        else if (renderHeader) {
            return renderHeader(data);
        }
        return react_1.default.createElement(HeaderTitle_1.default, { title: title });
    };
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.Platform.OS === 'web'
            ? {
                height,
                paddingRight: safeArea.right,
                paddingLeft: safeArea.left,
                paddingBottom: safeArea.bottom,
            }
            : {
                flex: 1,
                paddingRight: safeArea.right,
                paddingLeft: safeArea.left,
                paddingBottom: safeArea.bottom,
            } },
        react_1.default.createElement(Header_1.default, { style: react_native_1.StyleSheet.flatten([!headerShown && styles.hidden, headerStyle]) },
            renderHeaderTitleOrCustomHeader(),
            renderHeaderControls()),
        react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.screen, style]) },
            react_1.default.createElement(ActivityIndicator_1.default, { visible: transparentLoading }),
            loading && react_1.default.createElement(Loading_1.default, null),
            !loading && errorCondition && (react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(ui_1.Card, { style: {
                        margin: ui_1.getSpacing(),
                    } },
                    react_1.default.createElement(ui_1.CardContainer, null,
                        react_1.default.createElement(ui_1.Text, null, networkLinkState.hasNetworkError ? networkErrorText : serverErrorText),
                        react_1.default.createElement(ui_1.Button, { text: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F", color: "secondary", onPress: () => {
                                dispatch(retry());
                            } }))))),
            !loading && !errorCondition && renderMain(data))));
}
exports.default = Screen;
const styles = react_native_1.StyleSheet.create({
    headerControls: {
        marginTop: ui_1.getSpacing(),
    },
    statusBar: {
        backgroundColor: ui_1.Colors.white,
        flex: 0,
    },
    screen: {
        flex: 1,
        zIndex: -1,
        ...react_native_1.Platform.select({
            web: {
                touchAction: 'none',
                overscrollBehaviorY: 'contain',
            },
        }),
    },
    hidden: {
        display: 'none',
    },
});
